import { formatNumber } from './CodeWindow';

/**
 * Handle table data changes and update the table data state.
 *
 * @param {string} key - The unique key of the table row.
 * @param {string} field - The name of the field being changed.
 * @param {string|number} value - The new value of the field.
 * @param {string} ornamentid - The ID of the ornament.
 * @param {string} itemtypeid - The ID of the item type.
 * @param {string} itemtypesname - The name of the item type.
 * @param {Array} tableData - The current table data.
 * @param {Function} setTableData - Function to update the table data state.
 */
export const handleTableData = (
  primaryCalculationType,

  key,
  field,
  value,
  ornamentid,
  itemtypeid,
  itemtypesname,
  tableData,
  setTableData,
  isSalesEdit = false,
) => {
  const updatedData = tableData?.map((row, index) => {
    if (row.key === key) {
      let updatedRow = { ...row, [field]: value };
      if (field === 'isName') {
        updatedRow = {
          ...row,
          key: index + 1,
          [field]: itemtypesname,
          typeId: ornamentid,
          itemId: value,
          itemTypeId: itemtypeid,
          itemTypesName: value,
          unit: itemtypesname === 'Diamond' ? 'crt' : primaryCalculationType,
          disableUnit: itemtypesname?.toLowerCase() === 'diamond',
        };
      }
      return updatedRow;
    }
    return row;
  });

  const modifiedData = isSalesEdit
    ? updatedData?.map((item) => ({
        ...item,
        // purchaseRate: 0,
        // salesRate: item?.salesRate ? item.salesRate : 0,
        // weight: item?.weight ? item.weight : 0,
        // pcs: item?.pcs ? item.pcs : 0,
        rateOn: item?.rateOn ? item.rateOn : 'pcs',
      }))
    : updatedData?.map((item) => ({
        ...item,
        // purchaseRate: item?.purchaseRate ? item.purchaseRate : 0,
        // salesRate: item?.salesRate ? item.salesRate : 0,
        // weight: item?.weight ? item.weight : 0,
        // pcs: item?.pcs ? item.pcs : 0,
        rateOn: item?.rateOn ? item.rateOn : 'pcs',
      }));

  // setTableData(updatedData);
  setTableData(modifiedData);
};

//Dynamic

/**
 * Update totals for the form and table data.
 *
 * @param {Object} form - The form object to update fields.
 * @param {Function} setTotalPrate - Function to update the total purchase rate state.
 * @param {Function} setTotalPcsDiamond - Function to update the total diamond pieces state.
 * @param {Function} setTotalPcsStone - Function to update the total stone pieces state.
 * @param {Function} setTotalStoneWeight - Function to update the total stone weight state.
 * @param {Function} setTotalDiamondWeight - Function to update the total diamond weight state.
 * @param {Function} setTotalStoneAmount - Function to update the total stone amount state.
 * @param {Function} setTotalDiamondAmount - Function to update the total diamond amount state.
 * @param {Array} tableData - The current table data.
 * @param {Object} formData - The current form data.
 * @param {Function} setFormData - Function to update the form data state.
 */
export const updateTotals = (
  form,
  setTotalPrate,
  setTotalPcsDiamond,
  setTotalPcsStone,
  setTotalStoneWeight,
  setTotalDiamondWeight,
  setTotalStoneAmount,
  setTotalDiamondAmount,
  setTotalGramLalValue,
  tableData,
  formData,
  setFormData,
  primaryCalculationType,
  primaryWeight,
) => {
  let pcsDiamond = 0;
  let pcsStone = 0;
  let weightTotal = 0;
  let stoneTotal = 0;
  let diamondTotal = 0;
  let prateTotal = 0;
  let totalDiamondAmount = 0;
  let totalStoneAmount = 0;
  let realGramLalValue = 0;
  let rowUnit = '';

  const isSalesRate = [
    '/transaction/sales/create/',
    '/transaction/sales/order/create/',
    '/transaction/sales/order/edit/',
    '/transaction/sales/edit/',
    '/sales/create/',
    '/sales/edit/',
    '/sales/order/create/',
    '/sales/order/edit/',
    '/sales/return/',
  ].some((route) => window.location.pathname.includes(route));

  tableData?.forEach((row) => {
    if (
      (row.isName?.toLowerCase() || row?.itemTypeName?.toLowerCase()) ===
        'diamond' &&
      Number(row.pcs)
    ) {
      pcsDiamond += Number(row?.pcs);
    }
    if (
      (row.isName?.toLowerCase() || row?.itemTypeName?.toLowerCase()) ===
        'stone' &&
      Number(row.pcs)
    ) {
      pcsStone += Number(row.pcs);
    }
    if (
      (row.isName?.toLowerCase() || row?.itemTypeName?.toLowerCase()) ===
        'stone' &&
      Number(row.weight)
    ) {
      if (row.unit === 'gm' || row.unit === 'lal') {
        rowUnit = row.unit;
        const realValue = Number(row.weight);
        const gmvalue = Number(
          (row.weight / primaryWeight).toFixed(
            primaryCalculationType === 'lal' ? 1 : 3,
          ),
        );
        stoneTotal += gmvalue;
        realGramLalValue += Number(realValue);
      } else {
        //have to change in this line in case of the carrat
        stoneTotal += Number(row.weight);
        const gmlalWeight = Number(
          (row.weight * primaryWeight).toFixed(
            primaryCalculationType === 'lal' ? 1 : 3,
          ),
        );
        // const gmlalWeight = Number(row.weight * 1);
        realGramLalValue += gmlalWeight;
      }
    }

    //changed this line from row.unit Crt to crt
    if (
      (row.isName?.toLowerCase() || row?.itemTypeName?.toLowerCase()) ===
        'diamond' &&
      row?.unit?.toLowerCase() === 'crt' &&
      Number(row.weight)
    ) {
      diamondTotal += Number(row.weight);
    }

    if (Number(row.weight)) {
      weightTotal += Number(row.weight);
    }
    if (Number(row?.purchaseRate)) {
      prateTotal += Number(row?.purchaseRate);
    }

    if (
      (row.isName?.toLowerCase() || row?.itemTypeName?.toLowerCase()) ===
      'diamond'
    ) {
      if (row.rateOn === 'pcs') {
        // row.amount =
        //   Number(row.pcs || 0) *
        //   Number(row?.purchaseRate ? row?.purchaseRate : row?.salesRate || 0);

        const rowAmount =
          Number(row.pcs || 0) *
          // Number(row?.purchaseRate ? row?.purchaseRate : row?.salesRate || 0);
          Number(!isSalesRate ? row?.purchaseRate || 0 : row?.salesRate || 0);
        row.amount = formatNumber(rowAmount, 3);
        // totalDiamondAmount += Number(diamondamount);
        totalDiamondAmount += formatNumber(rowAmount, 3);
      } else if (row.rateOn === 'wt') {
        // row.amount =
        //   Number(row.weight || 0) *
        //   Number(row?.purchaseRate ? row?.purchaseRate : row?.salesRate || 0);
        const diamondamount =
          Number(row.weight || 0) *
          // Number(row?.purchaseRate ? row?.purchaseRate : row?.salesRate || 0);
          Number(!isSalesRate ? row?.purchaseRate || 0 : row?.salesRate || 0);
        row.amount = formatNumber(diamondamount, 3);
        // totalDiamondAmount += Number(diamondamount); row?.purchaseRate ? row?.purchaseRate : row?.salesRate
        totalDiamondAmount += formatNumber(diamondamount, 3);
      } else {
        const amount = Number(
          !isSalesRate ? row?.purchaseRate || 0 : row?.salesRate || 0,
        );
        row.amount = formatNumber(amount, 3);
        totalDiamondAmount += formatNumber(amount, 3);
      }
    }
    if (
      (row.isName?.toLowerCase() || row?.itemTypeName?.toLowerCase()) ===
      'stone'
    ) {
      if (row.rateOn === 'pcs') {
        // row.amount =
        //   Number(row.pcs || 0) *
        //   Number(row?.purchaseRate ? row?.purchaseRate : row?.salesRate || 0);
        const rowAmount =
          Number(row.pcs || 0) *
          // Number(row?.purchaseRate ? row?.purchaseRate : row?.salesRate || 0);
          Number(!isSalesRate ? row?.purchaseRate || 0 : row?.salesRate || 0);
        row.amount = formatNumber(rowAmount, 3);
        const stoneamount = row.amount;
        // totalStoneAmount += Number(stoneamount);
        totalStoneAmount += formatNumber(stoneamount, 3);
      } else if (row.rateOn === 'wt') {
        // row.amount =
        //   Number(row.weight || 0) *
        //   Number(row?.purchaseRate ? row?.purchaseRate : row?.salesRate || 0);
        const rowAmount =
          Number(row.weight || 0) *
          // Number(row?.purchaseRate ? row?.purchaseRate : row?.salesRate || 0);
          Number(!isSalesRate ? row?.purchaseRate || 0 : row?.salesRate || 0);
        row.amount = formatNumber(rowAmount, 3);
        const stoneamount = row.amount;
        // totalStoneAmount += Number(stoneamount);
        totalStoneAmount += formatNumber(stoneamount, 3);
      } else {
        const amount = Number(
          !isSalesRate ? row?.purchaseRate || 0 : row?.salesRate || 0,
        );
        row.amount = formatNumber(amount, 3);
        totalStoneAmount += formatNumber(amount, 3);
      }
    }
  });

  // setFormData({
  //   ...formData,
  //   diamondPcs: Number(pcsDiamond),
  //   stonePcs: Number(pcsStone),
  //   stoneWeightCrt: stoneTotal.toFixed(3),
  //   stoneWeightGram: realGramLalValue.toFixed(3),
  //   // primaryCalculationType === 'lal' || primaryCalculationType === 'gm'
  //   //   ? Number(stoneTotal * primaryWeight)
  //   //   : Number(stoneTotal / 5),
  //   diamondWeightCrt: diamondTotal,
  //   diamondWeightGram: Number(diamondTotal / 5),
  //   diamondAmount: Number(totalDiamondAmount).toFixed(3),
  //   stoneAmount: Number(totalStoneAmount).toFixed(3),
  // });
  // form.setFieldsValue({
  //   diamondPcs: Number(pcsDiamond),
  //   stonePcs: Number(pcsStone),
  //   stoneWeightCrt: stoneTotal.toFixed(3),
  //   stoneWeightGram: Number(realGramLalValue).toFixed(3),
  //   // primaryCalculationType === 'lal'
  //   //   ? Number(stoneTotal * primaryWeight)
  //   //   : Number(stoneTotal / 5),
  //   diamondWeightCrt: diamondTotal,
  //   diamondWeightGram: Number(diamondTotal / 5),
  //   diamondAmount: Number(totalDiamondAmount).toFixed(3),
  //   stoneAmount: Number(totalStoneAmount).toFixed(3),
  // });

  setTotalPcsDiamond(Number(pcsDiamond));
  setTotalPcsStone(pcsStone);
  setTotalStoneWeight(stoneTotal.toFixed(3));
  setTotalGramLalValue(realGramLalValue);
  setTotalDiamondWeight(Number(diamondTotal.toFixed(3)));
  setTotalPrate(prateTotal);
  setTotalStoneAmount(Number(totalStoneAmount).toFixed(3));
  setTotalDiamondAmount(Number(totalDiamondAmount).toFixed(3));
};

/**
 * Update totals for the return form and table data.
 *
 * @param {Object} form - The form object to update fields.
 * @param {Function} setTotalPrate - Function to update the total purchase rate state.
 * @param {Function} setTotalPcsDiamond - Function to update the total diamond pieces state.
 * @param {Function} setTotalPcsStone - Function to update the total stone pieces state.
 * @param {Function} setTotalStoneWeight - Function to update the total stone weight state.
 * @param {Function} setTotalDiamondWeight - Function to update the total diamond weight state.
 * @param {Function} setTotalStoneAmount - Function to update the total stone amount state.
 * @param {Function} setTotalDiamondAmount - Function to update the total diamond amount state.
 * @param {Array} tableData - The current table data.
 * @param {Object} formData - The current form data.
 * @param {Function} setFormData - Function to update the form data state.
 */
// export const updateReturnTotals = (
//   form,
//   setTotalPrate,
//   setTotalPcsDiamond,
//   setTotalPcsStone,
//   setTotalStoneWeight,
//   setTotalDiamondWeight,
//   setTotalStoneAmount,
//   setTotalDiamondAmount,
//   tableData,
//   formData,
//   setFormData,
// ) => {
//   let pcsDiamond = 0;
//   let pcsStone = 0;
//   let weightTotal = 0;
//   let stoneTotal = 0;
//   let diamondTotal = 0;
//   let prateTotal = 0;
//   let totalDiamondAmount = 0;
//   let totalStoneAmount = 0;
//   tableData?.forEach((row) => {
//     if (row.itemTypeName?.toLowerCase() === 'diamond' && Number(row.pcs)) {
//       pcsDiamond += Number(row.pcs);
//     }
//     if (row.itemTypeName?.toLowerCase() === 'stone' && Number(row.pcs)) {
//       pcsStone += Number(row.pcs);
//     }
//     if (row.itemTypeName?.toLowerCase() === 'stone' && Number(row.weight)) {
//       if (row.unit === 'gm' || row.unit === 'lal') {
//         const gmvalue = Number(row.weight) * 5;
//         stoneTotal += gmvalue;
//       } else {
//         stoneTotal += Number(row.weight);
//       }
//     }
//     if (
//       row.itemTypeName?.toLowerCase() === 'diamond' &&
//       row.unit === 'crt' &&
//       Number(row.weight)
//     ) {
//       diamondTotal += Number(row.weight);
//     }

//     if (Number(row.weight)) {
//       weightTotal += Number(row.weight);
//     }
//     if (Number(row?.purchaseRate)) {
//       prateTotal += Number(row?.purchaseRate);
//     }

//     if (row.itemTypeName?.toLowerCase() === 'diamond') {
//       if (row?.rateOn === 'pcs') {
//         row.amount =
//           Number(row.pcs) * Number(row?.purchaseRate || row?.salesRate);
//         const diamondamount = row?.amount;
//         totalDiamondAmount += Number(diamondamount);
//       } else {
//         row.amount =
//           Number(row?.weight) * Number(row?.purchaseRate || row?.salesRate);
//         const diamondamount = row.amount;
//         totalDiamondAmount += Number(diamondamount);
//       }
//     }
//     if (row?.itemTypeName?.toLowerCase() === 'stone') {
//       if (row?.rateOn === 'pcs') {
//         row.amount =
//           Number(row.pcs) * Number(row?.purchaseRate || row?.salesRate);
//         const stoneamount = row.amount;
//         totalStoneAmount += Number(stoneamount);
//       } else {
//         row.amount =
//           Number(row.weight) * Number(row?.purchaseRate || row?.salesRate);
//         const stoneamount = row.amount;
//         totalStoneAmount += Number(stoneamount);
//       }
//     }
//   });

//   setFormData({
//     ...formData,
//     diamondPcs: pcsDiamond,
//     stonePcs: pcsStone,
//     stoneWeightCrt: stoneTotal,
//     stoneWeightGram: stoneTotal / 5,
//     diamondWeightCrt: diamondTotal,
//     diamondWeightGram: diamondTotal / 5,
//     diamondAmount: Number(totalDiamondAmount).toFixed(3),
//     stoneAmount: Number(totalStoneAmount).toFixed(3),
//   });
//   form.setFieldsValue({
//     diamondPcs: pcsDiamond,
//     stonePcs: pcsStone,
//     stoneWeightCrt: stoneTotal,
//     stoneWeightGram: stoneTotal / 5,
//     diamondWeightCrt: diamondTotal,
//     diamondWeightGram: diamondTotal / 5,
//     diamondAmount: Number(totalDiamondAmount).toFixed(3),
//     stoneAmount: Number(totalStoneAmount).toFixed(3),
//   });

//   setTotalPcsDiamond(pcsDiamond);
//   setTotalPcsStone(pcsStone);
//   setTotalStoneWeight(stoneTotal);
//   setTotalDiamondWeight(diamondTotal);
//   setTotalPrate(prateTotal);
//   setTotalStoneAmount(Number(totalStoneAmount).toFixed(3));
//   setTotalDiamondAmount(Number(totalDiamondAmount).toFixed(3));
// };

/**
 * Deletes a row from the table data.
 * @param {Array} tableData - The current table data.
 * @param {Function} setTableData - The function to update the table data.
 * @param {string} key - The key of the row to be deleted.
 */
export const handleDeleteRow = (tableData, setTableData, key) => {
  if (tableData.length === 1) {
    setTableData([
      {
        key: '1',
        typeId: '',
        rateOn: '',
        pcs: '',
        unit: '',
        weight: '',
        purchaseRate: '',
        hc: '',
        color: '',
        clarity: '',
        cut: '',
        amount: 0,
        remark: '',
        isName: '',
        itemTypeId: '',
        itemTypesName: '',
        disabledUnit: false,
      },
    ]);
  } else {
    const updatedData = tableData.filter((row) => row.key !== key);
    const updatedDataWithKeys = updatedData?.map((row, index) => ({
      ...row,
      key: `${index + 1}`,
    }));
    setTableData(updatedDataWithKeys);
  }
};

export const handleAddRow = (tableData, setTableData) => {
  const newRow = {
    key: `${tableData.length + 1}`,
    typeId: '',
    rateOn: '',
    pcs: '',
    unit: '',
    weight: '',
    purchaseRate: '',
    hc: '',
    color: '',
    clarity: '',
    cut: '',
    amount: 0,
    remark: '',
    isName: '',
    itemTypeId: '',
    itemTypesName: '',
    disabledUnit: false,
  };
  setTableData([...tableData, newRow]);
};
